import { Phone } from "lucide-react";
import { PHONE_TEL, WA_LINK, LOGO_URL } from "../data/menuData";

const navLinks = [
  { label: "Menu", href: "#menu" },
  { label: "Why Us", href: "#why" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 bg-[#FAFAFA]/95 backdrop-blur border-b-2 border-black"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-10 lg:px-16 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-2.5"
        >
          <div className="w-11 h-11 md:w-12 md:h-12 brutal-border bg-black overflow-hidden flex items-center justify-center">
            <img
              src={LOGO_URL}
              alt="KKFC Bangarpet logo"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="leading-tight">
            <div className="font-display text-2xl md:text-3xl text-black">
              KKFC
            </div>
            <div className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-neutral-700 -mt-1">
              Bangarpet
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className="font-body text-sm font-semibold uppercase tracking-wide text-black hover:text-[#D92525] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="navbar-call-btn"
            className="hidden sm:inline-flex items-center gap-2 brutal-border brutal-shadow bg-[#FFB800] text-black font-semibold px-4 py-2 text-sm uppercase tracking-wide"
          >
            <Phone size={16} strokeWidth={2.5} />
            Call
          </a>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="navbar-whatsapp-btn"
            className="inline-flex items-center gap-2 brutal-border brutal-shadow bg-[#D92525] text-white font-semibold px-4 py-2 text-sm uppercase tracking-wide"
          >
            Order Now
          </a>
        </div>
      </div>
    </header>
  );
}
